function numOfDaysInCurrentMonth() {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
}
export default numOfDaysInCurrentMonth;
